'use client';

import { SearchCardClinic } from './variants/clinic/search-card-clinic.component';
import { SearchCardLaboratory } from './variants/laboratory/search-card-laboratory.component';

import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { CodesOrSlugsResponse } from '@/app/(main)/(pages)/busca/[slug]/_types/codes-or-slugs-response.type';
import { checkLaboratorialOrVaccineSearch } from '@/app/_utils/check-laboratorial-or-vaccine-search.util';
import { SearchType } from '@/types/most-search-type';

export type SearchCardComponentProps = {
  searchType: string;
  schedule: SearchPartnerData;
  proceduresResearched: CodesOrSlugsResponse;
  hasTopHr?: boolean;
  fluid?: boolean;
};

export const SearchCardComponent = (props: SearchCardComponentProps) => {
  if (checkLaboratorialOrVaccineSearch(props.searchType as SearchType)) {
    return <SearchCardLaboratory {...props} />;
  }

  return <SearchCardClinic {...props} />;
};
